export const pixelConfig = {
  pixelStart: 'datos_personales_v2',
  pixelSteps: [
    'ingresos_v2',
    'short_v2',
    'domicilio_v2',
    'bank_account_v2',
  ],
  pixelFinish: "short_v2",
  pixelShort: "short_v2",
  pixelShortConversion: "short_v2_conversion",
  pixelLargeConversion: "large_v2_conversion"
}